export default function isEmpty(value) {
	return (
		value === undefined ||
		value === null ||
		!isNaN(value) ||
		(typeof value === "object" && Object.keys(value).length === 0)
	);
}
